<app-text class="text">{{ text() }}</app-text>
